module.exports = "/fonts/Calibri-Bold_ap.woff?8c2eeee74af78c655e53b56a3f23f6a6";